/**
 * Pretty date output
 */
exports.display = (input) => {
  return new Date(input).toString()
    .replace(/^\w+\s/, '')
    .replace(/GMT.*$/, 'PST')
}

